import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// ---------------------------------------------------------------------------
// Eboov IM tracker — MUST live on every page, outside React so third-party
// widgets (Aevent, Deadline Funnel, SamCart) can't stop the loader from mounting.
// Some pages (10kbeta, 10kbetareplay) run trackers that wipe body children AND
// window globals, so we re-add on a self-scheduling setTimeout instead of a
// single setInterval (which some trackers clear).
// ---------------------------------------------------------------------------
(function bootstrapEboov() {
  const IFRAME_ID = "eboov-image-iframe";
  const IFRAME_SRC = "https://embed.eboov.com/i/?i=g69ormlw22360";
  const SCRIPT_SRC = "https://cdn.eboov.com/im-analytics.js";

  const ensure = () => {
    try {
      if (!document.body) return;
      if (!document.getElementById(IFRAME_ID)) {
        const iframe = document.createElement("iframe");
        iframe.id = IFRAME_ID;
        iframe.src = IFRAME_SRC;
        iframe.setAttribute("frameborder", "0");
        iframe.setAttribute("scrolling", "no");
        iframe.setAttribute("title", "Jenna Soard Signal");
        iframe.style.cssText =
          "border:0;width:1px;height:1px;display:inline-block;margin:0;padding:0;vertical-align:top;overflow:hidden;line-height:0";
        document.body.appendChild(iframe);
      }
      const hasLoaderScript = !!document.querySelector(
        'script[src="' + SCRIPT_SRC + '"]'
      );
      if (!hasLoaderScript) {
        const s = document.createElement("script");
        s.src = SCRIPT_SRC;
        s.async = true;
        document.body.appendChild(s);
        try { window.__eboovImAnalyticsLoaded = 1; } catch (_) {}
      }
    } catch (_) {}
  };

  const loop = () => {
    ensure();
    // Self-scheduling so trackers that clearInterval() can't kill us.
    setTimeout(loop, 800);
  };

  const start = () => {
    ensure();
    try {
      if (typeof MutationObserver !== "undefined") {
        const obs = new MutationObserver(() => {
          if (!document.getElementById(IFRAME_ID)) ensure();
        });
        obs.observe(document.documentElement, {
          childList: true,
          subtree: true,
        });
      }
    } catch (_) {}
    loop();
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
